/*
 * yt-facade.js — angelegt 02.09.2026
 *
 * YouTube-Embeds, die als roher <iframe> in Produkt- und Artikeltexten stehen,
 * werden durch ein Vorschaubild mit Play-Button ersetzt. Das echte iframe wird
 * erst nach einem Klick geladen.
 *
 * Vorher lud jede Produktseite mit Video beim Aufruf ein bis drei komplette
 * YouTube-Player mit — auch dann, wenn die Beschreibung zugeklappt war.
 *
 * Die Datei wird bewusst im <head> OHNE defer eingebunden, damit der
 * MutationObserver steht, bevor der Body geparst wird. Nur so lässt sich der
 * Ladevorgang der iframes noch abfangen.
 *
 * WICHTIG — Finger weg von den Video-Sections des Themes:
 * video-banner, video-with-text, video-with-text-yt und media-wall haben ihre
 * eigene Klick-Logik und ihr eigenes Layout. Deren iframes werden erst beim
 * Klick eingefügt und tragen autoplay=1 im src. Solche iframes werden hier
 * komplett in Ruhe gelassen — kein Vorschaubild, kein zusätzlicher Rahmen.
 * Ein zusätzlicher Rahmen würde z. B. die absolut positionierte
 * .vwt-video-wrapper-Box von video-with-text-yt zerlegen.
 *
 * Vimeo und andere Anbieter bekommen nur den responsiven Rahmen und loading=lazy,
 * genau wie vorher das Inline-Skript in layout/theme.liquid.
 */
(function () {
  'use strict';

  var SKIP_SELECTOR = 'deferred-media, .deferred-media, .yt-facade, .yt-facade__frame, .vwt-video, .vwt-video-wrapper, [data-no-facade]';
  var GENERIC_TITLES = ['youtube video player', 'youtube-videoplayer', ''];

  function injectStyles() {
    if (document.getElementById('yt-facade-styles')) return;
    var style = document.createElement('style');
    style.id = 'yt-facade-styles';
    style.textContent =
      '.yt-facade{position:relative;display:block;width:100%;aspect-ratio:16/9;margin:20px 0;padding:0;border:none;border-radius:12px;overflow:hidden;background:#000;cursor:pointer}' +
      '.yt-facade img{position:absolute;inset:0;width:100%;height:100%;object-fit:cover;display:block;border:none}' +
      '.yt-facade__play{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:68px;height:48px;border-radius:12px;background:rgba(0,0,0,.72);display:flex;align-items:center;justify-content:center;transition:background .15s ease}' +
      '.yt-facade:hover .yt-facade__play,.yt-facade:focus-visible .yt-facade__play{background:#f00}' +
      '.yt-facade__play svg{width:22px;height:24px;fill:#fff}' +
      '.yt-facade__frame{position:relative;width:100%;aspect-ratio:16/9;margin:20px 0;border-radius:12px;overflow:hidden;background:#000}' +
      '.yt-facade__frame iframe{position:absolute;inset:0;width:100%;height:100%;border:none}' +
      '.responsive-video-wrapper{position:relative;padding-bottom:56.25%;height:0;overflow:hidden;max-width:100%;border-radius:12px;background:#000;margin:20px 0}' +
      '.responsive-video-wrapper iframe{position:absolute;top:0;left:0;width:100%;height:100%;border:none;border-radius:12px}';
    (document.head || document.documentElement).appendChild(style);
  }

  function videoId(src) {
    var match = String(src).match(/\/embed\/([A-Za-z0-9_-]{6,})/);
    return match ? match[1] : '';
  }

  function labelFor(iframe) {
    var title = (iframe.getAttribute('title') || '').trim();
    if (GENERIC_TITLES.indexOf(title.toLowerCase()) === -1) return title;

    var node = iframe.parentElement;
    while (node && node !== document.body) {
      var prev = node.previousElementSibling;
      while (prev) {
        if (/^H[1-6]$/.test(prev.tagName)) {
          var text = (prev.textContent || '').replace(/\s+/g, ' ').trim();
          if (text) return text;
        }
        prev = prev.previousElementSibling;
      }
      node = node.parentElement;
    }
    return document.title || 'Video';
  }

  function play(box) {
    var id = box.getAttribute('data-yt-id');
    var label = box.getAttribute('data-yt-label') || 'Video';
    var frame = document.createElement('div');
    frame.className = 'yt-facade__frame';
    var iframe = document.createElement('iframe');
    iframe.setAttribute('src', 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0');
    iframe.setAttribute('title', label);
    iframe.setAttribute('allow', 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share');
    iframe.setAttribute('allowfullscreen', '');
    iframe.dataset.ytHandled = '1';
    frame.appendChild(iframe);
    if (box.parentNode) box.parentNode.replaceChild(frame, box);
    iframe.focus();
  }

  function buildFacade(iframe) {
    var src = iframe.getAttribute('src') || '';
    var id = videoId(src);
    if (!id) return false;

    var label = labelFor(iframe);
    iframe.removeAttribute('src');

    var box = document.createElement('button');
    box.type = 'button';
    box.className = 'yt-facade';
    box.setAttribute('data-yt-id', id);
    box.setAttribute('data-yt-label', label);
    box.setAttribute('aria-label', label);

    var img = document.createElement('img');
    img.setAttribute('loading', 'lazy');
    img.setAttribute('decoding', 'async');
    img.setAttribute('width', '480');
    img.setAttribute('height', '360');
    img.alt = '';
    img.setAttribute('aria-hidden', 'true');
    img.src = 'https://i.ytimg.com/vi/' + id + '/hqdefault.jpg';
    box.appendChild(img);

    var play_button = document.createElement('span');
    play_button.className = 'yt-facade__play';
    play_button.innerHTML = '<svg viewBox="0 0 22 24" aria-hidden="true" focusable="false"><path d="M2 1.5 20.5 12 2 22.5z"></path></svg>';
    box.appendChild(play_button);

    box.addEventListener('click', function (event) {
      event.preventDefault();
      play(box);
    });

    if (iframe.parentNode) iframe.parentNode.replaceChild(box, iframe);
    return true;
  }

  function wrapOther(iframe) {
    if (!iframe.getAttribute('loading')) iframe.setAttribute('loading', 'lazy');
    if (iframe.closest('.responsive-video-wrapper')) return;
    if (!iframe.parentNode) return;
    injectStyles();
    var wrapper = document.createElement('div');
    wrapper.className = 'responsive-video-wrapper';
    iframe.removeAttribute('width');
    iframe.removeAttribute('height');
    iframe.parentNode.insertBefore(wrapper, iframe);
    wrapper.appendChild(iframe);
  }

  function handle(iframe) {
    if (!iframe || iframe.dataset.ytHandled === '1') return;
    var src = iframe.getAttribute('src') || '';
    if (!src) return;
    if (iframe.closest && iframe.closest(SKIP_SELECTOR)) return;

    var isYoutube = /(?:youtube\.com|youtube-nocookie\.com)\/embed\//.test(src);
    var isVimeo = /player\.vimeo\.com/.test(src);
    if (!isYoutube && !isVimeo) return;

    // autoplay=1 heißt: das hat gerade jemand selbst gestartet, meist aus einer
    // Theme-Videosection heraus. Nicht anfassen, sonst zerlegen wir deren Layout.
    if (src.indexOf('autoplay=1') > -1) {
      iframe.dataset.ytHandled = '1';
      return;
    }

    iframe.dataset.ytHandled = '1';

    if (isYoutube) {
      injectStyles();
      if (buildFacade(iframe)) return;
    }
    wrapOther(iframe);
  }

  function scan(root) {
    if (!root || !root.querySelectorAll) return;
    var frames = root.querySelectorAll('iframe[src]');
    for (var i = 0; i < frames.length; i++) handle(frames[i]);
  }

  if (window.MutationObserver) {
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (node.tagName === 'IFRAME') handle(node);
          else scan(node);
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  document.addEventListener('DOMContentLoaded', function () {
    scan(document);
  });

  window.addEventListener('load', function () {
    scan(document);
  });
})();